<template>
<v-app>
  <v-navigation-drawer fixed :mini-variant="miniVariant" :clipped="true" v-model="drawer" app v-if="isLoggedIn && !error">
    <v-list>
      <v-list-tile v-for="(item, i) in items" :key="i" :to="item.link" value="true" exact activeClass="">
        <v-list-tile-action>
          <v-icon v-html="item.icon"></v-icon>
        </v-list-tile-action>
        <v-list-tile-content>
          <v-list-tile-title v-text="item.title"></v-list-tile-title>
        </v-list-tile-content>
      </v-list-tile>
      <v-list-tile activeClass="" @click="logout">
        <v-list-tile-action>
          <v-icon v-html="'exit_to_app'"></v-icon>
        </v-list-tile-action>
        <v-list-tile-content>
          <v-list-tile-title v-text="'Abmelden'"></v-list-tile-title>
        </v-list-tile-content>
      </v-list-tile>
    </v-list>
  </v-navigation-drawer>
  <v-toolbar fixed app :clipped-left="true" v-if="isLoggedIn && !error">
    <v-toolbar-side-icon @click.stop="drawer = !drawer"></v-toolbar-side-icon>
    <v-toolbar-title v-text="title"></v-toolbar-title>
    <v-spacer></v-spacer>
  </v-toolbar>
  <v-content v-if="isLoggedIn && !error">
    <router-view />
  </v-content>
  <v-footer :fixed="fixed" app v-if="isLoggedIn && !error">
    <span>&copy; 2017</span>
  </v-footer>
  <v-content v-if="!isLoggedIn && !error">
    <v-login />
  </v-content>
  <v-content v-if="error">
    <v-dialog :value="true" persistent max-width="350">
      <v-card>
        <v-card-text>{{ error.message }}</v-card-text>
        <v-card-actions>
          <v-btn color="primary" @click="closeError">OK</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-content>
</v-app>
</template>

<script>
import Login from './Login'
import Vue from 'vue'

var appData = {
  clipped: false,
  drawer: true,
  fixed: false,
  isLoggedIn: false,
  items: [{
    icon: 'dashboard',
    title: 'Übersicht',
    link: '/'
  }, {
    icon: 'build',
    title: 'Werkstattaufträge',
    link: '/ServiceOrderOverview'
  }, {
    icon: 'business_center',
    title: 'Einkäufe',
    link: '/OrderOverview'
  }, {
    icon: 'local_post_office',
    title: 'Nachrichten',
    link: '/Messages'
  }, {
    icon: 'chat',
    title: 'Chat',
    link: '/Chat'
  }, {
    icon: 'account_circle',
    title: 'Mein Konto',
    link: '/AccountOverview'
  }],
  miniVariant: false,
  right: true,
  rightDrawer: false,
  title: 'freeline Kundenportal',
  error: false,

  // login page
  account: {
    username: '',
    password: '',
    name: '',
    invoice_date: '',
    invoice_nr: '',
    invoice_total: '',
    customer_nr: '',
    phone: '',
    email: ''
  },
  login_selected_tab: 'login'
}

Vue.component('v-login', Login)
Object.defineProperty(Vue.prototype, '$appData', {
  get: () => appData
})

export default {
  data() {
    return appData
  },
  created() {
    this.$api.addEventListener('login', () => {
      this.$appData.isLoggedIn = true
      this.$api.user.accountGetInfo().then((response) => {
        this.$appData.account = response.data
      })
    })
    this.$api.addEventListener('logout', () => {
      this.$appData.isLoggedIn = false
    })
    this.$api.addEventListener('error', (event) => {
      this.$appData.error = event.detail
    })
  },
  methods: {
    logout: function(event) {
      this.$api.logout()
    },
    closeError: function(event) {
      this.$appData.error = false
    }
  }
}
</script>



// WEBPACK FOOTER //
// App.vue?cdba127e